import React from 'react';
import { CopyOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import type { Observer } from 'src/interfaces/entities/observer';
import { Button, Tooltip } from 'antd';

interface DuplicateObserverProps {
	row: Observer;
}

export default function DuplicateObserver({ row, }: DuplicateObserverProps) {
	const navigate = useNavigate();

	const handleDuplicate = () => {
		navigate(`/observador/adicionar?id=${row.observer_id}`);
	};

	return (
		<Tooltip title='Duplicar'>
			<Button type="text" onClick={handleDuplicate} icon={<CopyOutlined />} />
		</Tooltip>
	);
}